/**
 * The one full-page navigation the workspace performs.
 *
 * OAuth cannot start as a fetch — the provider round trip is a top-level
 * navigation by design — so the sign-in page leaves the SPA through here.
 * An object with a method rather than a bare function, because jsdom's
 * `location.assign` is an own, non-configurable property that no test can
 * patch; this seam is the testable surface, and it deliberately has exactly
 * one caller and one job.
 */
export const browserNavigation = {
  assign(url: string): void {
    window.location.assign(url);
  },
};
